<script>
  import AXHR from "../components/js/axhr.js";
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  //TABLE SECTION
  import QrCode from "svelte-qrcode";
  import Modal from "../components/Modal.svelte";
  import prettyB from "pretty-bytes";
  import format from "number-format.js";
  $: dataFiltered = [];
  function loadData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        let res;
        res = response.data;
        if (filter !== false) {
          res = res.filter((el) => {
            return el[filter.name] !== filter.value;
          });
        } else {
          res = res;
        }
        dataFiltered = res;
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  if (sessions) {
    loadData(
      sessions.api + "/rb/" + sessions.routeractive.id + "/ip-hotspot-user",
      sessions.token,
      { name: "default", value: true }
    );
  }

  function fillEdit(v) {
    document.getElementById("quickAddHotspotUser").reset();
    if (
      document.getElementById("formAddHotspotUser").classList.remove("hidden")
    ) {
      document.getElementById("formAddHotspotUser").classList.add("block");
    }
    document.getElementById("formAddHotspotUser").classList.add("shake");
    let val_disabled = "false";
    if (v.disabled === true) {
      val_disabled = true;
    } else {
      val_disabled = false;
    }
    let val_server = "all";
    if (v.server === undefined) {
      val_server = "all";
    } else {
      val_server = v.server;
    }
    let val_email = "";
    if (v.email) {
      val_email = v.email;
    } else {
      val_email = "";
    }
    let val_bytevalue = "";
    let val_bytetype = "MB";
    if (v.limitBytesTotal) {
      if (prettyB(v.limitBytesTotal).indexOf("GB") != -1) {
        val_bytevalue = v.limitBytesTotal / 1000000000;
        val_bytetype = "GB";
      } else {
        val_bytevalue = v.limitBytesTotal / 1000000;
        val_bytetype = "MB";
      }
    } else {
      val_bytevalue = "";
      val_bytetype = "MB";
    }
    let val_comment = "";
    if (v.comment) {
      if (v.comment.indexOf("vc-") != -1 || v.comment.indexOf("up-") != -1) {
        val_comment = v.comment.replace(/vc-/g, "");
        val_comment = val_comment.replace(/up-/g, "");
      } else {
        val_comment = v.comment;
      }
    } else {
      val_comment = "";
    }
    payload = {
      id: v.id,
      server: val_server,
      username: v.name,
      password: v.password,
      profile: v.profile,
      timelimit: v.limitUptime,
      bytevalue: val_bytevalue,
      bytetype: val_bytetype,
      comment: val_comment,
      email: val_email,
      disabled: val_disabled,
    };

    setTimeout(() => {
      document.getElementById("formAddHotspotUser").classList.remove("shake");
    }, 2500);
  }

  let selection = [];
  let selectionUser = [];
  let deleteSelected = false;

  $: console.log(selectionUser);
  $: if (selection.length > 0) {
    document.getElementById("selectAll").indeterminate = true;
    if (selection.length === dataFiltered.length) {
      setTimeout(() => {
        document.getElementById("selectAll").indeterminate = false;
      }, 100);
      document.getElementById("selectAll").checked = true;
    }
    deleteSelected = true;
  } else if (selection.length === 0) {
    setTimeout(() => {
      if (document.getElementById("selectAll")) {
        document.getElementById("selectAll").indeterminate = false;
      }
    }, 200);
    deleteSelected = false;
  }
  function SelectAll(state, css) {
    for (var i = 0; i < dataFiltered.length; i++) {
      if (document.getElementsByClassName(css)[i]) {
        document.getElementsByClassName(css)[i].checked = state;
        if (state == true) {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;
          selection = [
            ...selection,
            document.getElementsByClassName(css)[i].value,
          ];

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
          selectionUser = [
            ...selectionUser,
            document.getElementsByClassName(css)[i].getAttribute("data-user"),
          ];
        } else {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
        }
      }
    }
  }

  function SelectData(e) {
    if (e.target.checked == true) {
      console.log("kclas");
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;
      selection = [...selection, e.target.value];

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
      selectionUser = [...selectionUser, e.target.dataset.user];
    } else {
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
    }
  }
  function deleteSelectedUser(selection) {
    loading = true;
    let data = {
      selection: selection,
    };

    var config = {
      method: "delete",
      url:
        sessions.api + "/rb/" + sessions.routeractive.id + "/hotspot/user/mass",
      headers: {
        Authorization: "Bearer " + sessions.token,
        "Content-Type": "application/json",
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        setTimeout(() => {
          document.getElementById("selectAll").indeterminate = false;
        }, 100);
        document.getElementById("selectAll").checked = false;
        SelectAll(false, "idUser");
        if (response.data.length != undefined) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.length + " User Berhasil dihapus",
              color: "green",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "User " + response.data.name + " Berhasil dihapus",
              color: "green",
            },
          ];
        }
        loading = false;
        loadData(
          sessions.api + "/rb/" + sessions.routeractive.id + "/ip-hotspot-user",
          sessions.token,
          { name: "default", value: true }
        );
      })
      .catch(function (error) {
        loading = false;
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  //FORM SECTION

  $: profileFiltered = [];
  function loadprofileData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      profileFiltered = res;
    });
  }

  function onLoginDetail(prof, get, pure = false) {
    let strings = profileFiltered
      .filter((el) => {
        return el["name"] == prof;
      })[0]
      ["onLogin"].split(",");
    if (get == 1) {
      if (pure == true) {
        strings = strings[1];
      } else {
        if (strings[1] == "rem") {
          strings = "Remove";
        } else if (strings[1] == "ntf") {
          strings = "Notice";
        } else if (strings[1] == "remc") {
          strings = "Remove & Record";
        } else if (strings[1] == "ntfc") {
          strings = "Notice & Record";
        } else {
          strings = "";
        }
      }
    } else if (get == 2) {
      strings = strings[2];
    } else if (get == 3) {
      strings = strings[3];
    } else if (get == 4) {
      strings = strings[4];
    } else if (get == 5) {
      strings = strings[5];
    }
    return strings;
  }

  $: serverFiltered = [];
  function loadserverData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      serverFiltered = res;
    });
  }
  if (sessions) {
    loadprofileData(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-user-profile",
      sessions.token,
      false
    );
    loadserverData(
      sessions.api + "/rb/" + sessions.routeractive.id + "/ip-hotspot",
      sessions.token,
      false
    );
  }
  let loading = false;

  let payload;
  $: payload = {
    id: false,
    server: "all",
    username: "",
    password: "",
    profile: "",
    timelimit: "",
    bytevalue: "",
    bytetype: "MB",
    comment: "",
    email: "",
    disabled: false,
  };

  let require;

  $: require = {
    server: payload.server,
    username: payload.username,
    password: payload.password,
    profile: payload.profile,
  };
  let number;
  $: number = {
    bytevalue: payload.bytevalue,
  };

  let email;
  $: email = {
    email: payload.email,
  };
  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        if (require[n] != undefined || number[n] != "") {
          errorForm = [
            ...errorForm,
            { field: n, message: "Pastikan Hanya Angka" },
          ];
        }
        if (number[n] !== "") {
          if (document.getElementById(n + "-warning")) {
            document.getElementById(n + "-warning").style.display =
              "inline-block";
            document.getElementById(n + "-warning").innerHTML =
              "Pastikan Hanya Angka";
          }
          if (document.getElementById(n + "-labelwarning")) {
            document.getElementById(n + "-labelwarning").style.color =
              "rgb(255, 102, 102)";
          }
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        if (require[e] != undefined || email[e] !== "") {
          errorForm = [
            ...errorForm,
            { field: e, message: "Pastikan Email sudah tepat" },
          ];
        }
        if (email[e] !== "") {
          if (document.getElementById(e + "-warning")) {
            document.getElementById(e + "-warning").style.display =
              "inline-block";
            document.getElementById(e + "-warning").innerHTML =
              "Pastikan Email sudah tepat";
          }
          if (document.getElementById(e + "-labelwarning")) {
            document.getElementById(e + "-labelwarning").style.color =
              "rgb(255, 102, 102)";
          }
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  $: state = { title: "Quick Add", subtitle: "Create Hotspot User" };
  $: if (payload.id) {
    state = { title: "Quick Edit", subtitle: "Edit Hotspot User" };
  } else {
    state = { title: "Quick Add", subtitle: "Create Hotspot User" };
  }

  let success;
  $: success = false;
  async function handleSubmit() {
    let data;
    let method = "post";
    if (payload.id) {
      method = "put";

      data = {
        id: payload.id,
        server: payload.server,
        name: payload.username,
        password: payload.password,
        profile: payload.profile,
        timelimit: payload.timelimit,
        datalimit: payload.bytevalue,
        mbgb: payload.bytetype,
        comment: payload.comment,
        email: payload.email,
        disabled: payload.status,
      };
    } else {
      method = "post";
      data = {
        server: payload.server,
        name: payload.username,
        password: payload.password,
        profile: payload.profile,
        timelimit: payload.timelimit,
        datalimit: payload.bytevalue,
        mbgb: payload.bytetype,
        comment: payload.comment,
        email: payload.email,
        disabled: payload.status,
      };
    }
    loading = true;
    let valid;
    valid = validator();
    if (valid) {
      var config = {
        method: method,
        url: sessions.api + "/rb/" + sessions.routeractive.id + "/hotspot/user",
        headers: {
          Authorization: "Bearer " + sessions.token,
          "Content-Type": "application/json",
        },
        data: data,
      };

      AXHR(config)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "Perintah berhasil dieksekusi",
              color: "green",
            },
          ];
          success = true;
          loading = false;

          loadData(
            sessions.api +
              "/rb/" +
              sessions.routeractive.id +
              "/ip-hotspot-user",
            sessions.token,
            { name: "default", value: true }
          );
          setTimeout(() => {
            success = false;
            payload = {
              id: false,
              server: "all",
              username: "",
              password: "",
              profile: "",
              timelimit: "",
              bytevalue: "",
              bytetype: "MB",
              comment: "",
              email: "",
              disabled: false,
            };
          }, 500);
        })
        .catch(function (error) {
          success = false;
          loading = false;

          document.getElementById("formAddHotspotUser").classList.add("shake");
          setTimeout(() => {
            document
              .getElementById("formAddHotspotUser")
              .classList.remove("shake");
          }, 2500);
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      document.getElementById("formAddHotspotUser").classList.add("shake");
      setTimeout(() => {
        document.getElementById("formAddHotspotUser").classList.remove("shake");
      }, 2500);
    }
  }

  function expStatus(params) {
    if (params == "1s") {
      return "Expired";
    } else {
      return "OK";
    }
  }
  let loadTable = false;
  setTimeout(() => {
    loadTable = true;
  }, 500);

  import MakeSortable from "../components/MakeTable/MakeSortable.svelte";
  import SortHeader from "../components/MakeTable/SortHeader.svelte";
  let filter = "",
    imgsortIconCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>',
    imgsortIconAscCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path></svg>',
    imgsortIconDescCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" /></svg>';
</script>

<svelte:head>
  <title>Mikhub - Hotspot Users</title>
</svelte:head>
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-24 mx-auto mb-20 lg:pt-24 md:pt-20"
>
  <Title
    title="Hotspot Users"
    subtitle="Manage Your Hotspot Users"
    tipe="3"
    href="./"
  />
  <div class="mx-auto my-2 lg:my-2">
    <div class="relative block w-full gap-8 lg:flex md:block">
      <div
        class="w-full px-2 pt-5 pb-10 my-5 bg-white rounded-lg shadow-lg lg:w-9/12 md:w-full"
      >
        <!--TABLE SECTION-->
        {#if loadTable}
          <MakeSortable
            data={dataFiltered}
            let:table
            {filter}
            filterFields={[
              "addressPool",
              "name",
              "profile",
              "parentQueue",
              "rateLimit",
              "sharedUsers",
              "onLogin",
              "comment",
              "limitUptime",
            ]}
            sortIconCss={imgsortIconCss}
            sortIconAscCss={imgsortIconAscCss}
            sortIconDescCss={imgsortIconDescCss}
          >
            <div
              class="flex flex-wrap items-center justify-between w-full pr-2 mb-2"
            >
              <div
                class="flex justify-start w-1/2 gap-2 py-1 lg:w-4/12 md:w-2/6"
              >
                {#if deleteSelected}
                  <Modal backdropClose size="lg:w-2/5 w-full z-50">
                    <div class="mt-0 lg:mt-0 md:mt-4" slot="trigger" let:open>
                      {#if loading}
                        <button
                          on:click|preventDefault
                          class="px-2 py-1 text-xs text-red-100 bg-red-600 bg-opacity-50 rounded-md focus:outline-none hover:bg-red-500"
                          disabled>Memproses...</button
                        >
                      {:else}
                        <button
                          on:click={open}
                          class="px-2 py-1 text-xs text-red-100 bg-red-600 rounded-md focus:outline-none hover:bg-red-500"
                          >Delete Selected <i>({selection.length})</i></button
                        >
                      {/if}
                    </div>

                    <div slot="header">
                      <h1 class="text-lg">Delete This List ...?</h1>
                    </div>
                    <div slot="content" class="h-full">
                      <div class="w-full rounded-lg lg:px-2">
                        <div
                          class="flex gap-2 overflow-y-auto"
                          style="height:60vh"
                        >
                          <div class="w-1/2">
                            <table class="w-full table-fixed">
                              <thead class="w-full">
                                <th
                                  class="w-1/3 px-2 py-1 text-sm text-center bg-white border-b border-r border-gray-300"
                                  >#</th
                                >
                                <th
                                  class="w-2/3 px-2 py-1 text-sm text-center truncate whitespace-pre-wrap bg-white border-b border-r border-gray-300"
                                  >Name</th
                                >
                              </thead>
                              <tbody>
                                {#each selectionUser as s, i}
                                  <tr class="w-full hover:bg-gray-200">
                                    <td
                                      class="w-1/3 px-2 py-1 text-sm text-center text-gray-700 border-b border-r border-gray-300 odd:bg-white even:bg-gray-100"
                                      >{i + 1}</td
                                    >
                                    <td
                                      title={s}
                                      class="w-2/3 px-2 py-1 text-sm text-center text-gray-700 border-b border-r border-gray-300 odd:bg-white even:bg-gray-100"
                                      >{s}</td
                                    >
                                  </tr>
                                {/each}
                              </tbody>
                            </table>
                          </div>
                          <div class="sticky top-0 w-1/2 text-center">
                            <p
                              class="px-2 py-3 mx-2 mb-5 text-sm text-center text-red-800 bg-yellow-200 rounded"
                            >
                              The following is a list of users who will be
                              deleted, please make sure first
                            </p>
                            <button
                              on:click|preventDefault={() =>
                                deleteSelectedUser(selection)}
                              on:click={() =>
                                document
                                  .getElementsByClassName("backdrop")[0]
                                  .click()}
                              class="px-2 py-1 text-sm text-red-100 bg-red-600 rounded-md focus:outline-none hover:bg-red-500"
                              >Delete Now <i>({selection.length})</i></button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                {:else}
                  <div class="mt-0 lg:mt-0 md:mt-4">
                    <button
                      on:click={() =>
                        loadData(
                          sessions.api +
                            "/rb/" +
                            sessions.routeractive.id +
                            "/ip-hotspot-user",
                          sessions.token,
                          { name: "default", value: true }
                        )}
                      class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
                      ><svg
                        class="inline w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg> Refresh</button
                    >
                  </div>
                {/if}
              </div>
              <div
                class="flex items-center justify-end w-1/2 gap-4 px-2 py-1 text-xs lg:w-4/12 md:w-2/6"
              >
                <span>Total : <b>{table.rows.length}</b></span><span
                  >Filtered : <b>{table.sortedAndFilteredRows.length}</b></span
                >
              </div>
              <input
                type="text"
                class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
                placeholder="Search..."
                bind:value={filter}
              />
            </div>

            <div class="w-full">
              <div
                transition:fade
                class="sticky z-10 w-full mb-5 bg-gray-100 border-b-4 border-gray-400 rounded-lg shadow-lg lg:shadow-lg md:shadow-lg lg:top-20 md:top-20 top-16"
              >
                <div
                  class="flex flex-no-wrap items-end justify-start w-full overflow-x-auto cursor-pointer lg:items-center md:items-end"
                >
                  <div class="w-8 p-2 text-sm italic font-bold">
                    <label for="selectAll">
                      <input
                        on:click={(e) => SelectAll(e.target.checked, "idUser")}
                        type="checkbox"
                        id="selectAll"
                        class="mx-1 my-1 text-xl rounded-lg form-checkbox hover:shadow-outline"
                      />
                    </label>
                  </div>
                  <SortHeader
                    css="w-52 p-2 text-sm font-bold italic"
                    path={(row) => String(row.name)}>Username</SortHeader
                  >
                  <SortHeader
                    css="w-24 p-2 text-sm font-bold italic"
                    path={(row) => row.bytesIn + row.bytesOut}>Bytes</SortHeader
                  >
                  <SortHeader
                    css="lg:w-56 md:48 w-40 p-2 text-sm font-bold italic"
                    path={(row) => String(row.profile)}>Profile</SortHeader
                  >
                  <SortHeader
                    css="w-44 p-2 text-sm font-bold italic"
                    path={(row) => String(row.comment)}>Comment</SortHeader
                  >
                  <SortHeader
                    css="w-44 p-2 text-sm font-bold italic"
                    path={(row) => expStatus(row.limitUptime)}
                    >Status</SortHeader
                  >
                </div>
              </div>

              <div class="flex flex-wrap w-full gap-1">
                {#if table.pageRows.length > 0}
                  {#each table.pageRows as d}
                    <div
                      class="w-full mx-0 my-2 overflow-hidden rounded-lg shadow-md lg:my-1 md:my-1 hover:bg-gray-100"
                    >
                      <label
                        for="select-{d.name}"
                        class="flex flex-wrap items-center justify-start w-full"
                      >
                        <div class="w-8 p-2 text-sm">
                          {#if selection.some(function (el) {
                            return el == d.id;
                          })}
                            <input
                              on:click={(e) => SelectData(e)}
                              name="id[]"
                              bind:group={selection}
                              id="select-{d.name}"
                              data-user={d.name}
                              type="checkbox"
                              value={d.id}
                              class="my-1 text-xl rounded-lg idUser form-checkbox hover:shadow-outline"
                              selected
                            />
                          {:else}
                            <input
                              on:click={(e) => SelectData(e)}
                              name="id[]"
                              bind:group={selection}
                              id="select-{d.name}"
                              data-user={d.name}
                              type="checkbox"
                              value={d.id}
                              class="my-1 text-xl rounded-lg idUser form-checkbox hover:shadow-outline"
                            />
                          {/if}
                        </div>
                        <div
                          class="p-2 text-sm w-52"
                          on:click|preventDefault={fillEdit(d)}
                        >
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Username
                          </div>
                          {#if d.disabled}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              class="inline w-4"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                              />
                            </svg>
                          {/if}
                          {#if d.name}
                            {String(d.name)}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Bytes
                          </div>

                          {#if d.bytesIn || d.bytesOut}
                            {prettyB(d.bytesIn + d.bytesOut)}
                          {/if}
                        </div>
                        <div class="w-40 p-2 text-sm lg:w-56 md:48">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Profile
                          </div>
                          {d.profile}
                        </div>

                        <div class="p-2 text-sm w-44">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Comment
                          </div>
                          {String(d.comment)}
                        </div>
                        <div class="p-2 text-sm w-44">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Status
                          </div>
                          {#if d.limitUptime}
                            {expStatus(d.limitUptime)}
                          {/if}
                        </div>
                      </label>
                    </div>
                  {/each}
                {:else}
                  {#if filter}
                    <div class="flex items-center justify-center w-full h-full">
                      <div class="text-center">
                        <span class="italic text-gray-900 animate-pulse text-md"
                          >Data Not Found</span
                        >
                      </div>
                    </div>
                  {:else}
                    <div class="flex items-center justify-center w-full h-full">
                      <div class="text-center">
                        <span class="italic text-gray-900 animate-pulse text-md"
                          >Data Not Found</span
                        >
                      </div>
                    </div>
                  {/if}

                  <div class="flex items-center justify-center w-full h-full">
                    <div class="text-center">
                      <img
                        src="./assets/logo/logo_icon.svg"
                        alt="Mikhub Loading"
                        class="w-20 h-20 mx-auto animate-spin"
                        width="50"
                        height="50"
                      />
                    </div>
                  </div>
                {/if}
              </div>
            </div>
            <div
              class="flex flex-no-wrap items-center justify-center w-full my-5 rounded-lg"
            >
              <div
                class="flex items-center justify-center w-10 h-10 bg-white rounded-l-lg shadow"
                class:bg-gray-300={table.paging.currentPage === 0}
              >
                <button
                  class="w-full h-full focus:outline-none"
                  on:click={table.paging.onPrevious}>&laquo;</button
                >
              </div>
              {#each table.paging.buttons as btn (btn)}
                <div
                  class="flex items-center justify-center w-10 h-10 bg-white shadow"
                  class:bg-gray-300={btn.active}
                >
                  <button
                    class="w-full h-full focus:outline-none"
                    on:click={btn.onClick}>{btn.label}</button
                  >
                </div>
              {/each}
              <div
                class="flex items-center justify-center w-10 h-10 bg-white rounded-r-lg shadow"
                class:bg-gray-300={table.paging.currentPage >=
                  table.paging.pageCount - 1}
              >
                <button
                  class="w-full h-full focus:outline-none"
                  on:click={table.paging.onNext}>&raquo;</button
                >
              </div>
            </div>
          </MakeSortable>
        {:else}
          <div class="flex items-center justify-center w-full h-full">
            <div class="text-center">
              <img
                src="./assets/logo/logo_icon.svg"
                alt="Mikhub Loading"
                class="w-20 h-20 mx-auto animate-spin"
                width="50"
                height="50"
              />
              <span class="italic text-gray-900 animate-pulse text-md"
                >loading</span
              >
            </div>
          </div>
        {/if}
        <!--/TABLE SECTION-->
      </div>
      <!--FORM SECTION-->
      <div
        class="fixed bottom-0 right-0 z-10 block w-10 mb-20 mr-5 lg:z-auto md:z-auto lg:hidden md:block lg:right-0 lg:bottom-0 lg:mt-0 lg:mr-5"
      >
        <a
          href="./hotspot-user-add"
          on:click|preventDefault={() => {
            document
              .getElementById("formAddHotspotUser")
              .classList.remove("hidden");
            document
              .getElementById("formAddHotspotUser")
              .classList.add("block");
            payload = {
              id: false,
              server: "all",
              username: "",
              password: "",
              profile: "",
              timelimit: "",
              bytevalue: "",
              bytetype: "MB",
              comment: "",
              email: "",
            };
          }}
          class="flex items-center justify-center w-10 h-10 text-xl text-center text-white bg-blue-600 rounded-full shadow-md lg:w-auto md:w-auto active:bg-gray-500 focus:outline-none hover:bg-blue-400"
          >+</a
        >
      </div>
      <div
        id="formAddHotspotUser"
        class="fixed top-0 left-0 right-0 z-50 hidden w-full h-screen p-5 py-0 my-0 overflow-y-auto bg-white rounded-none shadow-lg lg:overflow-y-none md:overflow-y-auto lg:h-full md:h-screen lg:block lg:py-5 md:py-5 lg:z-auto md:z-50 lg:my-5 md:my-0 lg:rounded-lg md:rounded-lg lg:w-3/12 md:w-full lg:sticky md:fixed"
      >
        <div
          class="h-auto pt-0 pb-20 md:pt-0 lg:pb-0 md:pb-b lg:h-auto md:h-auto lg:pt-0"
        >
          <div class="sticky top-0 z-10 lg:z-0 md:z-10 lg:block md:block">
            <Title title={state.title} subtitle={state.subtitle} tipe="1" />
          </div>

          {#if success}
            <div class="w-full" on:click={() => (success = false)}>
              <div
                class="w-full p-2 mx-auto mb-2 text-xs bg-gray-300 border-4 border-t border-b border-r border-gray-600 border-solid rounded shadow-lg color-white"
              >
                <h2
                  class="relative flex items-center justify-between text-sm font-bold"
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      class="inline-block w-4 h-4"
                    >
                      <path
                        d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0 1 16 8v6l3
              2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z"
                      />
                    </svg>
                    Berhasil
                  </span>
                  <span
                    class="absolute top-0 right-0 -mt-2 text-sm font-bold text-gray-700"
                    on:click={() => (success = false)}>x</span
                  >
                </h2>
                <p>
                  Kamu berhasil {#if payload.id != false}
                    Menggubah
                  {:else}
                    Menambah
                  {/if} user di server {sessions.routeractive.name}
                </p>
              </div>
            </div>
          {/if}

          <form
            class="px-2 pt-2"
            autocomplete="off"
            on:submit|preventDefault={handleSubmit}
            id="quickAddHotspotUser"
          >
            <section class="mt-5">
              <label for="server" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="server"
                  id="server"
                  autocomplete="off"
                  type="text"
                  placeholder="Hotspot Server"
                  bind:value={payload.server}
                >
                  <option value="all">all</option>
                  {#each serverFiltered as p}
                    <option value={p.name}>{p.name}</option>
                  {/each}
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="server-labelwarning"
                  >Hotspot Server
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="server-warning"
                />
              </label>
            </section>
            <section class="mt-5">
              <label for="username" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="username"
                  id="username"
                  autocomplete="off"
                  type="text"
                  placeholder="Username"
                  bind:value={payload.username}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="username-labelwarning"
                  >Username
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="username-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="password" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="password"
                  id="password"
                  autocomplete="off"
                  type="password"
                  placeholder="Kata Sandi"
                  bind:value={payload.password}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="password-labelwarning"
                  >Kata Sandi
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="password-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="profile" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="profile"
                  id="profile"
                  autocomplete="off"
                  type="text"
                  placeholder="profile"
                  bind:value={payload.profile}
                >
                  <option value="" />
                  {#each profileFiltered as p}
                    <option value={p.name}>{p.name}</option>
                  {/each}
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="profile-labelwarning"
                  >Profile
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="profile-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="timelimit" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="timelimit"
                  id="timelimit"
                  autocomplete="off"
                  type="text"
                  placeholder="Time Limit"
                  bind:value={payload.timelimit}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="timelimit-labelwarning"
                  >Time Limit
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="timelimit-warning"
                />
                <p class="text-xs text-right text-gray-500">
                  ex: 30d = 30hari, 12h = 12jam, 4w3d = 31hari
                </p>
              </label>
            </section>
            <section class="flex gap-2 mt-5">
              <label
                for="bytevalue"
                class="relative block w-7/12 text-sm font-light"
              >
                <input
                  class="w-full rounded-lg form-input"
                  name=""
                  id="bytevalue"
                  autocomplete="off"
                  type="text"
                  placeholder="Quota"
                  bind:value={payload.bytevalue}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="bytevalue-labelwarning"
                  >Quota
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="bytevalue-warning"
                />
              </label>
              <label
                for="bytetype"
                class="relative block w-5/12 text-sm font-light"
              >
                <select
                  class="w-full rounded-lg form-input"
                  name="bytetype"
                  id="bytetype"
                  autocomplete="off"
                  type="text"
                  placeholder="bytetype"
                  bind:value={payload.bytetype}
                >
                  <option>MB</option>
                  <option>GB</option>
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="bytetype-labelwarning"
                  >MB/GB
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="profile-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="comment" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="comment"
                  id="comment"
                  autocomplete="off"
                  type="text"
                  placeholder="Comment"
                  bind:value={payload.comment}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="comment-labelwarning"
                  >Comment
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="comment-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="email" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="email"
                  id="email"
                  autocomplete="off"
                  type="text"
                  placeholder="Email"
                  bind:value={payload.email}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="email-labelwarning"
                  >Email
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="email-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="status" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="status"
                  id="status"
                  autocomplete="off"
                  type="text"
                  placeholder="status"
                  bind:value={payload.status}
                >
                  <option value="true">Disable</option>
                  <option value="false">Enable</option>
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="status-labelwarning"
                  >Status
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="status-warning"
                />
              </label>
            </section>

            <div
              class="flex justify-between w-full gap-2 lg:justify-between md:justify-start"
            >
              {#if loading}
                <button
                  type="submit"
                  class="w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                  disabled="disabled"
                >
                  MEMPROSES...
                </button>
              {:else}
                <button
                  type="submit"
                  class="w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                  on:click={handleSubmit}
                >
                  SAVE
                </button>
              {/if}

              <button
                type="button"
                on:click|preventDefault={() => {
                  document
                    .getElementById("formAddHotspotUser")
                    .classList.remove("block");
                  document
                    .getElementById("formAddHotspotUser")
                    .classList.add("hidden");
                }}
                class="block w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg lg:hidden md:block text-1xl active:bg-gray-500 focus:outline-none"
              >
                CANCEL
              </button>
              <button
                type="button"
                on:click|preventDefault={() => {
                  payload = {
                    id: false,
                    server: "all",
                    username: "",
                    password: "",
                    profile: "",
                    timelimit: "",
                    bytevalue: "",
                    bytetype: "MB",
                    comment: "",
                    email: "",
                  };
                }}
                class="hidden w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg lg:block md:hidden text-1xl active:bg-gray-500 focus:outline-none"
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </div>

      <!--/FORM SECTION-->
    </div>
  </div>
</main>

{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-50 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
